import React from "react";

const HowLoadboardWorks = () => {
  return (
    <div className="bg-black text-white py-16 px-6 sm:px-10 md:px-20 overflow-x-hidden">
      <div className="max-w-[1400px] mx-auto flex flex-col items-center">
        {/* Title and Purple Underline */}
        <div className="mb-12 flex flex-col items-center w-full">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-24 h-1 bg-purple-600 rounded"></div>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-center">
            How Loadboard <span className="text-purple-600">Works</span>
          </h2>
        </div>

        {/* Content Wrapper */}
        <div className="w-full flex flex-col lg:flex-row gap-12 items-center lg:items-start">
          {/* Left: Text */}
          <div className="w-full lg:w-1/2 flex justify-center lg:justify-end pr-0 lg:pr-8">
            <ul className="space-y-8 text-left w-full max-w-[600px] pl-5">
            <li className="flex flex-col gap-2 relative">
              <div className="absolute -left-5 top-2.5 w-2 h-2 rounded-full bg-gray-300"></div>
              <h3 className="text-xl font-bold text-white leading-tight">
                Load Posting by Brokers & Shippers
              </h3>
              <p className="text-gray-300 text-[16px] leading-relaxed">
                Brokers and shippers post import and export container loads with
                pickup location, destination, schedule, and load details.
              </p>
            </li>

            <li className="flex flex-col gap-2 relative">
              <div className="absolute -left-5 top-2.5 w-2 h-2 rounded-full bg-gray-300"></div>
              <h3 className="text-xl font-bold text-white leading-tight">
                AI-Powered Smart Matching
              </h3>
              <p className="text-gray-300 text-[16px] leading-relaxed">
                Our platform uses AI to instantly match loads with nearby,
                prequalified owner-operators based on port proximity,
                availability, and compliance.
              </p>
            </li>

            <li className="flex flex-col gap-2 relative">
              <div className="absolute -left-5 top-2.5 w-2 h-2 rounded-full bg-gray-300"></div>
              <h3 className="text-xl font-bold text-white leading-tight">
                Instant Dispatch via Dispax
              </h3>
              <p className="text-gray-300 text-[16px] leading-relaxed">
                Once matched, loads are automatically dispatched in real time to
                drivers through Dispax, our integrated driver app, and the
                dispatch panel—eliminating manual coordination.
              </p>
            </li>

            <li className="flex flex-col gap-2 relative">
              <div className="absolute -left-5 top-2.5 w-2 h-2 rounded-full bg-gray-300"></div>
              <h3 className="text-xl font-bold text-white leading-tight">
                Search & Book Loads in Dispax
              </h3>
              <p className="text-gray-300 text-[16px] leading-relaxed">
                Owner-operators can view available container loads in Dispax, apply
                filters by port, destination, and timing, and book loads instantly.
              </p>
            </li>

            <li className="flex flex-col gap-2 relative">
              <div className="absolute -left-5 top-2.5 w-2 h-2 rounded-full bg-gray-300"></div>
              <h3 className="text-xl font-bold text-white leading-tight">
                Direct Communication & Compliance
              </h3>
              <p className="text-gray-300 text-[16px] leading-relaxed">
                Dispax enables direct communication between drivers, brokers, and
                shippers while ensuring all owner-operators meet DOT and
                compliance standards.
              </p>
            </li>

            <li className="flex flex-col gap-2 relative">
              <div className="absolute -left-5 top-2.5 w-2 h-2 rounded-full bg-gray-300"></div>
              <h3 className="text-xl font-bold text-white leading-tight">
                Efficient Execution & Tracking
              </h3>
              <p className="text-gray-300 text-[16px] leading-relaxed">
                From pickup to delivery, loads are executed smoothly with
                real-time updates, reduced empty miles, minimized downtime, and
                improved port-to-port efficiency.
              </p>
            </li>
          </ul>
        </div>

        {/* Right: Images */}
        <div className="w-full lg:w-1/2 flex flex-col sm:flex-row lg:flex-col gap-8 justify-center items-center lg:items-start pl-0 lg:pl-8">
          <img 
            src="/loadboard.png" 
            alt="Loadboard Overview" 
            className="w-full max-w-[500px] rounded-2xl shadow-[0_0_40px_rgba(147,51,234,0.15)] border border-purple-500/20 object-contain hover:scale-[1.02] transition-transform duration-300" 
          />
          <img 
            src="/loadboard2.png" 
            alt="Loadboard Details" 
            className="w-full max-w-[500px] rounded-2xl shadow-[0_0_40px_rgba(147,51,234,0.15)] border border-purple-500/20 object-contain hover:scale-[1.02] transition-transform duration-300" 
          />
        </div>
        </div>
      </div>
    </div>
  );
};

export default HowLoadboardWorks;
